import React from 'react';
import { ArrowRight, Phone, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Accessibility = () => {
  const navigate = useNavigate();

  return (
    <div className="container py-16" data-testid="accessibility-page">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-[#2C3E2D] hover:text-[#D97706] transition-colors mb-8"
      >
        <ArrowRight className="w-5 h-5" />
        <span className="font-medium">חזרה</span>
      </button>

      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-bold text-[#2C3E2D] mb-8 text-center" style={{ fontFamily: 'Heebo, sans-serif' }}>
          הצהרת נגישות
        </h1>

        <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6 text-stone-600 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-[#2C3E2D] mb-3">מחויבות לנגישות</h2>
            <p>
              אנו מחויבים להבטיח שהאתר שלנו יהיה נגיש לכלל המשתמשים, כולל אנשים עם מוגבלויות. 
              אנו פועלים בהתאם לתקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות), 
              התשע"ג-2013 ותקן הנגישות הישראלי (ת"י 5568).
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#2C3E2D] mb-3">התאמות הנגישות באתר</h2>
            <ul className="list-disc list-inside space-y-2 mr-4">
              <li>אפשרות להגדלה והקטנה של גודל הטקסט</li>
              <li>ניגודיות צבעים גבוהה</li>
              <li>הדגשת קישורים</li>
              <li>סמן עכבר מוגדל</li>
              <li>מבנה אתר ברור וקל לניווט</li>
              <li>טקסט חלופי לתמונות</li>
              <li>תאימות לקוראי מסך</li>
              <li>ניווט באמצעות מקלדת</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#2C3E2D] mb-3">שימוש בתפריט הנגישות</h2>
            <p>
              באתר קיים כפתור נגישות (סמל אדם בעיגול כחול) בצד ימין למטה של המסך. 
              לחיצה על הכפתור תפתח תפריט עם אפשרויות להתאמת תצוגת האתר לצרכיכם.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#2C3E2D] mb-3">דפדפנים נתמכים</h2>
            <p>
              האתר תומך בדפדפנים המובילים בגרסאותיהם העדכניות: Chrome, Firefox, Safari, Edge.
              מומלץ להשתמש בגרסה העדכנית ביותר של הדפדפן לחוויה מיטבית.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#2C3E2D] mb-3">פניות בנושא נגישות</h2>
            <p className="mb-4">
              אם נתקלתם בבעיית נגישות באתר, או שיש לכם הצעות לשיפור, אנא פנו אלינו:
            </p>
            <div className="bg-stone-50 rounded-xl p-4 space-y-3">
              <a 
                href="https://wa.me/972539406051?text=היי,+הגעתי+דרך+האתר+ואשמח+למידע+נוסף"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#2C3E2D] hover:text-[#D97706] transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>053-940-6051</span>
              </a>
              <div className="flex items-center gap-2 text-[#2C3E2D]">
                <Mail className="w-5 h-5" />
                <span>menshealth.il12345@gmail.com</span>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#2C3E2D] mb-3">תאריך עדכון</h2>
            <p>
              הצהרת נגישות זו עודכנה לאחרונה בתאריך: {new Date().toLocaleDateString('he-IL', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Accessibility;
